import { SizeCodeType } from 'entities/SizeCode/model/types';

export const getSizeCodeTypeString = (sizeCodeType?: SizeCodeType): string => {
  switch (sizeCodeType) {
    case SizeCodeType.CUBIC_BOX:
      return 'm³';
    case SizeCodeType.OFFICE:
      return 'm²';
    case SizeCodeType.STANDART_BOX:
      return 'm²';
    default:
      return 'm²';
  }
};
